// Pure selection helpers for the invoices list so the bulk-select behaviour is
// testable without rendering the whole page.

// Toggle a single id in a Set, returning a new Set (never mutating the input).
export function toggleId(selected, id) {
  const next = new Set(selected);
  if (next.has(id)) next.delete(id);
  else next.add(id);
  return next;
}

// State of a "select all" control for a group of items.
// Returns 'all' | 'some' | 'none' — 'some' maps to the indeterminate (mixed) UI.
export function groupSelectState(items, selected) {
  const ids = items.map((i) => i.id);
  if (ids.length === 0) return 'none';
  const count = ids.filter((id) => selected.has(id)).length;
  if (count === 0) return 'none';
  if (count === ids.length) return 'all';
  return 'some';
}

// Radix Checkbox `checked` value for a group header: true | false | 'indeterminate'.
export function groupCheckedValue(items, selected) {
  const state = groupSelectState(items, selected);
  if (state === 'all') return true;
  if (state === 'some') return 'indeterminate';
  return false;
}

// Toggle every item in a group: if all are selected, clear them; otherwise add all.
export function toggleGroup(items, selected) {
  const ids = items.map((i) => i.id);
  const allSelected = ids.length > 0 && ids.every((id) => selected.has(id));
  const next = new Set(selected);
  ids.forEach((id) => { if (allSelected) next.delete(id); else next.add(id); });
  return next;
}
